import { customElement } from 'lit/decorators';
import { css, html, LitElement } from 'lit';
import { Html } from '../../Application';

export default {
    icon,
    carfax,
    analyse,
    auto,
    bereik,
    calc,
    calendar,
    camera,
    clock,
    close,
    concurrentie,
    dashboard,
    dealer,
    download,
    dropdown,
    edit,
    goedzo,
    hamburger,
    info,
    kenteken,
    leads,
    logout,
    loop,
    next,
    pin,
    highlight,
    pointer,
    prev,
    print,
    prospects,
    settings,
    trash,
    vergelijken,
    video,
    voorraad,
};

export function carfax(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 368 73">
            <path
                d="M359.88 71.97H8.12c-3.91 0-7.09-3.12-7.09-6.95V7.98c0-3.83 3.18-6.95 7.09-6.95h351.76c3.91 0 7.09 3.12 7.09 6.95v57.04c0 3.83-3.18 6.95-7.09 6.95zM8.12 4.03c-2.25 0-4.09 1.77-4.09 3.95v57.04c0 2.18 1.83 3.95 4.09 3.95h351.76c2.25 0 4.09-1.77 4.09-3.95V7.98c0-2.18-1.83-3.95-4.09-3.95H8.12z"
            />
            <path
                d="M6.88 6.89v59.23h56.69V6.89H6.88zM36.53 57.3c-11.76 0-18.02-8.69-18.02-20.43 0-12.74 7.46-20.42 18.08-20.42 9.73 0 13.57 4.18 16.28 11.64l-9.95 3.92C41.51 28.32 40.15 26 36.53 26c-4.58 0-6.56 4.59-6.56 10.88 0 6.07 1.92 10.89 6.68 10.89 3.45 0 4.92-1.87 7.07-5.61l9.27 4.94c-2.66 5.17-7.08 10.2-16.46 10.2zM66.41 6.89v59.23h56.69V6.89H66.41zm36.57 49.33l-2.15-7H88.96l-2.15 7H75.06l14.36-39.57h11.08l14.36 39.57h-11.88z"
            />
            <path
                d="M94.9 28.07c-.51 2.66-1.13 4.85-2.55 9.88l-.73 2.6h6.56l-.73-2.6c-1.42-5.09-2.04-7.23-2.55-9.88zM155.01 25.77h-6.62v8.66h6.45c3.57 0 4.98-1.58 4.98-4.41 0-2.49-1.36-4.25-4.81-4.25z"
            />
            <path
                d="M125.93 6.89v59.23h56.69V6.89h-56.69zm33.32 49.52l-6.45-13.36h-4.41v13.36H137.6V16.84h17.7c9.28 0 15.44 3.51 15.44 12.89 0 5.94-2.78 9.6-7.12 11.57l7.92 15.1h-12.29zM185.46 6.89v59.23h56.69V6.89h-56.69zm43.98 19.27h-20.41v5.52h12.38v9.26h-12.38v15.48h-10.91V16.84h31.32v9.32z"
            />
            <g>
                <path
                    d="M272.92 28.38c-.51 2.66-1.13 4.86-2.54 9.88l-.74 2.6h6.56l-.73-2.6c-1.41-5.09-2.03-7.23-2.55-9.88z"
                />
                <path
                    d="M244.98 6.89v59.23h56.69V6.89h-56.69zm36.03 49.64l-2.15-7h-11.87l-2.15 7h-11.76l14.36-39.57h11.08l14.36 39.57h-11.87z"
                />
            </g>
            <path
                d="M304.5 6.81v59.23h56.69V6.81H304.5zm22.17 57.7l1.91-2.65c1.61-2.47 3.22-5.18 4.21-7.26 1.05 2.14 2.6 4.78 4.15 7.26l1.72 2.65h-11.99zm33 0h-7.26L339.6 46.28l13.67-19.24h-13.61l-2.41 3.82c-1.55 2.47-3.22 5.12-4.21 7.2-.93-2.08-2.6-4.73-4.14-7.2l-2.41-3.82h-13.92l13.68 19.46-13 18h-7.21V8.32h53.64c-.01 1.47-.01 54.73-.01 56.19z"
            />
        </svg>
    `);
}

export function analyse(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M11.67,11.71l0.27,1.24c0.02,0.06,0.01,0.12-0.02,0.18s-0.08,0.09-0.13,0.11c0,0-0.75,0.26-1.7,0.26 c-1.22,0-2.28-0.34-3.2-1.02c-0.91-0.68-1.53-1.59-1.86-2.75H4.3c-0.07,0-0.13-0.02-0.18-0.07C4.07,9.61,4.05,9.55,4.05,9.48V8.6 c0-0.07,0.02-0.13,0.07-0.18C4.17,8.38,4.23,8.35,4.3,8.35h0.52C4.8,8.05,4.8,7.78,4.82,7.53H4.3c-0.07,0-0.13-0.02-0.18-0.07 S4.05,7.35,4.05,7.28V6.39c0-0.07,0.02-0.13,0.07-0.18S4.22,6.14,4.3,6.14h0.77c0.35-1.09,0.98-1.97,1.9-2.64 c0.92-0.67,1.96-1,3.13-1c0.53,0,1.04,0.06,1.52,0.18c0.06,0.02,0.11,0.05,0.16,0.12c0.03,0.06,0.04,0.12,0.02,0.19l-0.34,1.24 c-0.02,0.07-0.05,0.12-0.11,0.15c-0.06,0.03-0.12,0.04-0.19,0.02c0,0-0.52-0.13-1.09-0.13c-0.66,0-1.25,0.17-1.77,0.5 C7.78,5.1,7.39,5.56,7.13,6.14h3.66c0.08,0,0.15,0.03,0.2,0.09c0.05,0.06,0.07,0.13,0.05,0.2l-0.19,0.89 c-0.03,0.14-0.11,0.2-0.25,0.2H6.78C6.77,7.72,6.77,8,6.78,8.35h3.59c0.08,0,0.14,0.03,0.2,0.09c0.05,0.06,0.06,0.13,0.05,0.21 l-0.19,0.88c-0.01,0.06-0.04,0.11-0.09,0.14s-0.1,0.06-0.16,0.06H7.16c0.25,0.61,0.64,1.09,1.17,1.45c0.53,0.36,1.12,0.54,1.79,0.54 c0.64,0,1.24-0.19,1.24-0.19c0.07-0.03,0.14-0.02,0.2,0.02C11.62,11.58,11.66,11.64,11.67,11.71z"
            />
        </svg>
    `);
}

export function auto(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 16">
            <path
                id="XMLID_24_"
                d="M17.21,5.66h-0.93c-0.21,0-0.39,0.08-0.53,0.21c-0.51-1.13-1.18-2.88-1.56-3.57 C14.03,2,13.68,1.63,13.3,1.63H4.7C4.32,1.63,3.97,2,3.8,2.3C3.42,2.99,2.75,4.74,2.25,5.87C2.11,5.74,1.92,5.66,1.71,5.66H0.79 C0.35,5.66,0,6.01,0,6.45c0,0.44,0.35,0.79,0.79,0.79h0.83c0,0,0,0.01,0,0.01v2.91c0,0.02,0,0.04,0,0.07c0,0.02,0,0.04,0,0.06v0.03 l0,0c0.03,0.93,0.5,1.67,1.07,1.67c0,0,0.01,0,0.01,0c0,0.04-0.01,0.08-0.01,0.12v1.54c0,0.4,0.32,0.73,0.73,0.73h0.68 c0.4,0,0.73-0.33,0.73-0.73V12.1c0-0.04-0.01-0.08-0.01-0.12l0.12,0h8.18l0.12,0c-0.01,0.04-0.01,0.08-0.01,0.12v1.54 c0,0.4,0.32,0.73,0.73,0.73h0.67c0.4,0,0.73-0.33,0.73-0.73V12.1c0-0.04-0.01-0.08-0.01-0.12h0c0.59,0,1.07-0.79,1.07-1.77 c0-0.01,0-0.02,0-0.02l0-2.95c0,0,0-0.01,0-0.01h0.83c0.43,0,0.79-0.35,0.79-0.79C18,6.01,17.65,5.66,17.21,5.66 M4.67,10.18 c-0.62,0-1.12-0.5-1.12-1.12c0-0.62,0.5-1.12,1.12-1.12c0.62,0,1.12,0.5,1.12,1.12C5.79,9.68,5.29,10.18,4.67,10.18 M12.98,10.18 c-0.62,0-1.12-0.5-1.12-1.12c0-0.62,0.5-1.12,1.12-1.12c0.62,0,1.12,0.5,1.12,1.12C14.1,9.68,13.6,10.18,12.98,10.18 M3.2,6.56 C3.69,5.51,4.13,4.02,4.69,3c0.04-0.07,0.16-0.24,0.25-0.27h4.02h0.09h4.02c0.09,0.04,0.21,0.2,0.25,0.27 c0.57,1.03,1.01,2.52,1.5,3.56H3.2z"
            />
        </svg>
    `);
}

export function bereik(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M16,13v1H0V2h1v11H16z M15,3.25v3.4c0,0.11-0.05,0.19-0.15,0.23s-0.19,0.02-0.28-0.06l-0.95-0.95 l-4.95,4.95C8.63,10.87,8.57,10.9,8.5,10.9s-0.13-0.03-0.18-0.08L6.5,9l-3.25,3.25l-1.5-1.5l4.57-4.57C6.37,6.13,6.43,6.1,6.5,6.1 s0.13,0.03,0.18,0.08L8.5,8l3.62-3.62l-0.95-0.95c-0.08-0.08-0.1-0.18-0.06-0.28S11.24,3,11.35,3h3.4c0.07,0,0.13,0.02,0.18,0.07 S15,3.18,15,3.25z"
            />
        </svg>
    `);
}

export function calc(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M13.5,1h-11c-0.55,0-1,0.45-1,1v12c0,0.55,0.45,1,1,1h11c0.55,0,1-0.45,1-1V2C14.5,1.45,14.05,1,13.5,1z M3.5,14c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1C4.5,13.55,4.05,14,3.5,14z M3.5,11c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1 s1,0.45,1,1C4.5,10.55,4.05,11,3.5,11z M3.5,8c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1C4.5,7.55,4.05,8,3.5,8z M6.5,14 c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1C7.5,13.55,7.05,14,6.5,14z M6.5,11c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1 s1,0.45,1,1C7.5,10.55,7.05,11,6.5,11z M6.5,8c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1C7.5,7.55,7.05,8,6.5,8z M9.5,14 c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1C10.5,13.55,10.05,14,9.5,14z M9.5,11c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1 s1,0.45,1,1C10.5,10.55,10.05,11,9.5,11z M9.5,8c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1C10.5,7.55,10.05,8,9.5,8z M13.5,13c0,0.55-0.45,1-1,1s-1-0.45-1-1v-3c0-0.55,0.45-1,1-1s1,0.45,1,1V13z M12.5,8c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1 s1,0.45,1,1C13.5,7.55,13.05,8,12.5,8z M13.5,4.5C13.5,4.78,13.28,5,13,5H3C2.72,5,2.5,4.78,2.5,4.5v-2C2.5,2.22,2.72,2,3,2h10 c0.28,0,0.5,0.22,0.5,0.5V4.5z"
            />
        </svg>
    `);
}

export function calendar(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M12.72,3.72h-0.86V3c0-0.55-0.45-1-1-1h-0.59c-0.55,0-1,0.45-1,1v0.72H6.71V3c0-0.55-0.45-1-1-1H5.12 c-0.55,0-1,0.45-1,1v0.72H3.28c-0.47,0-0.85,0.38-0.85,0.85v8.58c0,0.47,0.38,0.85,0.85,0.85h9.44c0.47,0,0.85-0.38,0.85-0.85V4.57 C13.57,4.1,13.19,3.72,12.72,3.72z M5,3.06c0-0.11,0.09-0.2,0.2-0.2h0.46c0.11,0,0.2,0.09,0.2,0.2v1.96c0,0.11-0.09,0.2-0.2,0.2H5.2 C5.09,5.21,5,5.12,5,5.01V3.06z M5.21,13.14H3.29v-1.93h1.93V13.14z M5.21,10.79H3.29V8.64h1.93V10.79z M5.21,8.21H3.29V6.29h1.93 V8.21z M7.79,13.14H5.64v-1.93h2.14V13.14z M7.79,10.79H5.64V8.64h2.14V10.79z M7.79,8.21H5.64V6.29h2.14V8.21z M10.35,13.14H8.21 v-1.93h2.14V13.14z M10.35,10.79H8.21V8.64h2.14V10.79z M10.35,8.21H8.21V6.29h2.14V8.21z M10.15,5.01V3.06c0-0.11,0.09-0.2,0.2-0.2 h0.46c0.11,0,0.2,0.09,0.2,0.2v1.96c0,0.11-0.09,0.2-0.2,0.2h-0.46C10.24,5.21,10.15,5.12,10.15,5.01z M12.71,13.14h-1.93v-1.93 h1.93V13.14z M12.71,10.79h-1.93V8.64h1.93V10.79z M12.71,8.21h-1.93V6.29h1.93V8.21z"
            />
        </svg>
    `);
}

export function camera(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M13.43,4.86v6c0,0.94-0.77,1.71-1.71,1.71H2.28c-0.94,0-1.71-0.77-1.71-1.71v-6 c0-0.94,0.77-1.71,1.71-1.71h1.5l0.34-0.91c0.17-0.44,0.69-0.8,1.16-0.8h3.43c0.47,0,0.99,0.36,1.16,0.8l0.34,0.91h1.5 C12.66,3.14,13.43,3.91,13.43,4.86z M10,7.86c0-1.65-1.35-3-3-3s-3,1.35-3,3s1.35,3,3,3S10,9.51,10,7.86z M8.93,7.86 c0,1.06-0.86,1.93-1.93,1.93S5.07,8.92,5.07,7.86S5.94,5.93,7,5.93S8.93,6.79,8.93,7.86z"
            />
        </svg>
    `);
}

export function clock(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M8 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM8 3.75C5.66 3.75 3.75 5.66 3.75 8S5.66 12.25 8 12.25s4.25-1.91 4.25-4.25S10.34 3.75 8 3.75zm1 5c0 .14-.11.25-.25.25h-2.5C6.11 9 6 8.89 6 8.75v-.5c0-.14.11-.25.25-.25H8V5.25c0-.14.11-.25.25-.25h.5c.14 0 .25.11.25.25v3.5z"
            />
        </svg>
    `);
}

export function close(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M11.45 3.68L10.32 2.55 7 5.87 3.68 2.55 2.55 3.68 5.87 7 2.55 10.32 3.68 11.45 7 8.13 10.32 11.45 11.45 10.32 8.13 7"
            />
        </svg>
    `);
}

export function concurrentie(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M14.5 4.8v1c0 .4-.1.7-.3 1.1-.2.4-.5.7-.9 1-.4.3-.8.6-1.4.8-.5.2-1 .3-1.6.3-.3.3-.5.5-.8.7-.2.2-.3.4-.4.6-.1.2-.1.4-.1.7 0 .3.1.5.2.7.2.2.5.3.8.3.4 0 .7.1 1 .4.3.2.5.5.5.9v.5c0 .1 0 .1-.1.2s-.1 0-.2 0H4.8c-.1 0-.1 0-.2-.1s-.1-.1-.1-.2v-.5c0-.4.2-.7.5-.9.3-.2.6-.3 1-.3.3 0 .6-.1.8-.3.1-.2.2-.4.2-.7 0-.3 0-.5-.1-.7-.1-.2-.2-.4-.4-.6-.3-.2-.5-.4-.8-.7-.6 0-1.1-.1-1.6-.4-.5-.2-1-.5-1.4-.8-.4-.2-.7-.6-.9-.9-.2-.4-.3-.8-.3-1.1v-1c0-.2.1-.4.2-.5.2-.2.3-.3.5-.3h2.2v-.8c0-.3.1-.6.4-.9.3-.2.6-.3 1-.3h4.5c.3 0 .6.1.9.4.2.2.4.5.4.9V4h2.2c.2 0 .4.1.5.2.1.2.2.3.2.6zM5.1 7.9c-.4-.8-.6-1.8-.6-2.9h-2v.8c0 .4.2.8.7 1.3s1.1.6 1.9.8zm8.4-2.1V5h-2c0 1.1-.2 2.1-.6 2.9.7-.2 1.3-.4 1.8-.9s.8-.8.8-1.2z"
            />
        </svg>
    `);
}

export function dashboard(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M5,3.25v1.5c0,0.21-0.07,0.39-0.22,0.53C4.64,5.43,4.46,5.5,4.25,5.5h-2.5c-0.21,0-0.39-0.07-0.53-0.22 C1.07,5.14,1,4.96,1,4.75v-1.5c0-0.21,0.07-0.39,0.22-0.53C1.36,2.57,1.54,2.5,1.75,2.5h2.5c0.21,0,0.39,0.07,0.53,0.22 C4.93,2.86,5,3.04,5,3.25z M5,7.25v1.5c0,0.21-0.07,0.39-0.22,0.53C4.64,9.43,4.46,9.5,4.25,9.5h-2.5c-0.21,0-0.39-0.07-0.53-0.22 C1.07,9.14,1,8.96,1,8.75v-1.5c0-0.21,0.07-0.39,0.22-0.53C1.36,6.57,1.54,6.5,1.75,6.5h2.5c0.21,0,0.39,0.07,0.53,0.22 C4.93,6.86,5,7.04,5,7.25z M5,11.25v1.5c0,0.21-0.07,0.39-0.22,0.53c-0.15,0.15-0.32,0.22-0.53,0.22h-2.5 c-0.21,0-0.39-0.07-0.53-0.22C1.07,13.14,1,12.96,1,12.75v-1.5c0-0.21,0.07-0.39,0.22-0.53c0.15-0.15,0.32-0.22,0.53-0.22h2.5 c0.21,0,0.39,0.07,0.53,0.22C4.93,10.86,5,11.04,5,11.25z M10,3.25v1.5c0,0.21-0.07,0.39-0.22,0.53C9.64,5.43,9.46,5.5,9.25,5.5 h-2.5c-0.21,0-0.39-0.07-0.53-0.22C6.07,5.14,6,4.96,6,4.75v-1.5c0-0.21,0.07-0.39,0.22-0.53C6.36,2.57,6.54,2.5,6.75,2.5h2.5 c0.21,0,0.39,0.07,0.53,0.22C9.93,2.86,10,3.04,10,3.25z M10,7.25v1.5c0,0.21-0.07,0.39-0.22,0.53C9.64,9.43,9.46,9.5,9.25,9.5h-2.5 c-0.21,0-0.39-0.07-0.53-0.22C6.07,9.14,6,8.96,6,8.75v-1.5c0-0.21,0.07-0.39,0.22-0.53C6.36,6.57,6.54,6.5,6.75,6.5h2.5 c0.21,0,0.39,0.07,0.53,0.22C9.93,6.86,10,7.04,10,7.25z M10,11.25v1.5c0,0.21-0.07,0.39-0.22,0.53c-0.15,0.15-0.32,0.22-0.53,0.22 h-2.5c-0.21,0-0.39-0.07-0.53-0.22C6.07,13.14,6,12.96,6,12.75v-1.5c0-0.21,0.07-0.39,0.22-0.53c0.15-0.15,0.32-0.22,0.53-0.22h2.5 c0.21,0,0.39,0.07,0.53,0.22C9.93,10.86,10,11.04,10,11.25z M15,3.25v1.5c0,0.21-0.07,0.39-0.22,0.53 c-0.15,0.15-0.32,0.22-0.53,0.22h-2.5c-0.21,0-0.39-0.07-0.53-0.22C11.07,5.14,11,4.96,11,4.75v-1.5c0-0.21,0.07-0.39,0.22-0.53 c0.15-0.15,0.32-0.22,0.53-0.22h2.5c0.21,0,0.39,0.07,0.53,0.22C14.93,2.86,15,3.04,15,3.25z M15,7.25v1.5 c0,0.21-0.07,0.39-0.22,0.53c-0.15,0.15-0.32,0.22-0.53,0.22h-2.5c-0.21,0-0.39-0.07-0.53-0.22C11.07,9.14,11,8.96,11,8.75v-1.5 c0-0.21,0.07-0.39,0.22-0.53c0.15-0.15,0.32-0.22,0.53-0.22h2.5c0.21,0,0.39,0.07,0.53,0.22C14.93,6.86,15,7.04,15,7.25z M15,11.25 v1.5c0,0.21-0.07,0.39-0.22,0.53c-0.15,0.15-0.32,0.22-0.53,0.22h-2.5c-0.21,0-0.39-0.07-0.53-0.22C11.07,13.14,11,12.96,11,12.75 v-1.5c0-0.21,0.07-0.39,0.22-0.53c0.15-0.15,0.32-0.22,0.53-0.22h2.5c0.21,0,0.39,0.07,0.53,0.22C14.93,10.86,15,11.04,15,11.25z"
            />
        </svg>
    `);
}

export function dealer(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <g id="XMLID_19_">
                <path id="XMLID_34_" class="st0" d="M2 6H3V7H2z" />
                <path id="XMLID_35_" class="st0" d="M2 9H3V10H2z" />
                <path id="XMLID_36_" class="st0" d="M6 9H10V10H6z" />
                <path id="XMLID_37_" class="st0" d="M6 6H10V7H6z" />
                <path id="XMLID_38_" class="st0" d="M6 3H10V4H6z" />
                <path
                    id="XMLID_41_"
                    class="st0"
                    d="M12,3V0H4v3H0v13h16V3H12z M1,15V4h3v11H1z M7,15v-2h2v2H7z M10,15v-3H6v3H5V1h6v14H10z M15,15 h-3V4h3V15z"
                />
                <path id="XMLID_45_" class="st0" d="M2 12H3V13H2z" />
                <path id="XMLID_46_" class="st0" d="M13 6H14V7H13z" />
                <path id="XMLID_47_" class="st0" d="M13 9H14V10H13z" />
                <path id="XMLID_48_" class="st0" d="M13 12H14V13H13z" />
            </g>
        </svg>
    `);
}

export function download(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M14.5,10.75v2.5c0,0.21-0.07,0.39-0.22,0.53C14.14,13.93,13.96,14,13.75,14H2.25 c-0.21,0-0.39-0.07-0.53-0.22c-0.15-0.15-0.22-0.32-0.22-0.53v-2.5c0-0.21,0.07-0.39,0.22-0.53C1.86,10.07,2.04,10,2.25,10h3.63 l1.05,1.06C7.24,11.35,7.59,11.5,8,11.5s0.76-0.15,1.06-0.44L10.12,10h3.62c0.21,0,0.39,0.07,0.53,0.22 C14.43,10.36,14.5,10.54,14.5,10.75z M11.96,6.3c0.09,0.21,0.05,0.4-0.11,0.55l-3.5,3.5C8.26,10.45,8.14,10.5,8,10.5 s-0.26-0.05-0.35-0.15l-3.5-3.5C3.99,6.7,3.95,6.52,4.04,6.3C4.13,6.1,4.28,6,4.5,6h2V2.5c0-0.14,0.05-0.25,0.15-0.35 C6.75,2.05,6.86,2,7,2h2c0.14,0,0.25,0.05,0.35,0.15C9.45,2.25,9.5,2.36,9.5,2.5V6h2C11.72,6,11.87,6.1,11.96,6.3z M11.35,12.85 c0.1-0.1,0.15-0.22,0.15-0.35c0-0.14-0.05-0.25-0.15-0.35C11.25,12.05,11.14,12,11,12c-0.14,0-0.25,0.05-0.35,0.15 c-0.1,0.1-0.15,0.22-0.15,0.35c0,0.14,0.05,0.25,0.15,0.35C10.75,12.95,10.86,13,11,13C11.14,13,11.25,12.95,11.35,12.85z M13.35,12.85c0.1-0.1,0.15-0.22,0.15-0.35c0-0.14-0.05-0.25-0.15-0.35C13.25,12.05,13.14,12,13,12c-0.14,0-0.25,0.05-0.35,0.15 c-0.1,0.1-0.15,0.22-0.15,0.35c0,0.14,0.05,0.25,0.15,0.35C12.75,12.95,12.86,13,13,13C13.14,13,13.25,12.95,13.35,12.85z"
            />
        </svg>
    `);
}

export function dropdown(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M10.85,4.9C10.95,5,11,5.11,11,5.25c0,0.14-0.05,0.25-0.15,0.35l-3.5,3.5C7.25,9.2,7.14,9.25,7,9.25 c-0.14,0-0.25-0.05-0.35-0.15l-3.5-3.5C3.05,5.5,3,5.39,3,5.25C3,5.11,3.05,5,3.15,4.9c0.1-0.1,0.22-0.15,0.35-0.15h7 C10.64,4.75,10.75,4.8,10.85,4.9z"
            />
        </svg>
    `);
}

export function edit(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M7.58,3.17l3.25,3.25l-6.5,6.5H1.08V9.67L7.58,3.17z M3.92,11.92l0.71-0.71L2.79,9.37l-0.71,0.71v0.84h1v1 H3.92z M8,4.67C8,4.55,7.95,4.5,7.83,4.5c-0.05,0-0.1,0.02-0.13,0.05L3.46,8.79C3.43,8.82,3.41,8.87,3.41,8.92 c0,0.11,0.06,0.17,0.17,0.17c0.05,0,0.1-0.02,0.13-0.05L7.95,4.8C7.99,4.76,8,4.72,8,4.67z M12.92,3.92c0,0.28-0.1,0.51-0.29,0.7 l-1.3,1.3L8.08,2.67l1.3-1.29c0.19-0.2,0.42-0.3,0.7-0.3c0.28,0,0.51,0.1,0.71,0.3l1.84,1.83C12.82,3.41,12.92,3.65,12.92,3.92z"
            />
        </svg>
    `);
}

export function goedzo(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path
                d="M5.44,16.84c0,0.42-0.34,0.76-0.76,0.76H1.26c-0.42,0-0.76-0.34-0.76-0.76v-7.6 c0-0.42,0.34-0.76,0.76-0.76h3.42c0.42,0,0.76,0.34,0.76,0.76V16.84z M2.78,14.56c-0.43,0-0.76,0.34-0.76,0.76 c0,0.43,0.33,0.76,0.76,0.76c0.42,0,0.76-0.33,0.76-0.76C3.54,14.9,3.2,14.56,2.78,14.56z M18.85,11.01 c0.13,0.38,0.18,0.74,0.18,0.9c0.02,0.59-0.15,1.15-0.51,1.63c0.13,0.44,0.13,0.91,0,1.39c-0.12,0.44-0.34,0.83-0.64,1.12 c0.07,0.89-0.13,1.62-0.58,2.15c-0.51,0.61-1.29,0.91-2.34,0.93c-0.05,0-0.21,0-0.43,0h-0.9h-0.2c-1.7,0-3.3-0.56-4.58-1 c-0.75-0.26-1.46-0.51-1.88-0.52c-0.4-0.01-0.76-0.34-0.76-0.76V9.23c0-0.39,0.33-0.72,0.72-0.76c0.44-0.04,1.58-1.45,2.1-2.14 c0.43-0.55,0.83-1.06,1.2-1.42c0.46-0.46,0.59-1.18,0.74-1.86c0.13-0.7,0.27-1.44,0.78-1.94c0.14-0.14,0.33-0.23,0.53-0.23 c2.66,0,2.66,2.13,2.66,3.04c0,0.97-0.34,1.66-0.66,2.28c-0.13,0.26-0.25,0.38-0.34,0.76h3.29c1.24,0,2.28,1.04,2.28,2.28 C19.5,9.87,19.25,10.55,18.85,11.01z"
            />
        </svg>
    `);
}

export function hamburger(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <g id="XMLID_442_">
                <path id="XMLID_445_" d="M0 2.5H20V5.5H0z" />
                <path id="XMLID_446_" class="st0" d="M0 8.5H20V11.5H0z" />
                <path id="XMLID_447_" class="st0" d="M0 14.5H20V17.5H0z" />
            </g>
        </svg>
    `);
}

export function info(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M10.5,12v1c0,0.14-0.05,0.25-0.15,0.35c-0.1,0.1-0.22,0.15-0.35,0.15H6c-0.14,0-0.25-0.05-0.35-0.15 C5.55,13.25,5.5,13.14,5.5,13v-1c0-0.14,0.05-0.25,0.15-0.35c0.1-0.1,0.22-0.15,0.35-0.15h0.5v-3H6c-0.14,0-0.25-0.05-0.35-0.15 C5.55,8.25,5.5,8.14,5.5,8V7c0-0.14,0.05-0.25,0.15-0.35C5.75,6.55,5.86,6.5,6,6.5h3c0.14,0,0.25,0.05,0.35,0.15 C9.45,6.75,9.5,6.86,9.5,7v4.5H10c0.14,0,0.25,0.05,0.35,0.15C10.45,11.75,10.5,11.86,10.5,12z M9.5,3v1.5 c0,0.14-0.05,0.25-0.15,0.35C9.25,4.95,9.14,5,9,5H7C6.86,5,6.75,4.95,6.65,4.85C6.55,4.75,6.5,4.64,6.5,4.5V3 c0-0.14,0.05-0.25,0.15-0.35C6.75,2.55,6.86,2.5,7,2.5h2c0.14,0,0.25,0.05,0.35,0.15C9.45,2.75,9.5,2.86,9.5,3z"
            />
        </svg>
    `);
}

export function kenteken(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <g>
                <path
                    fill="#FFEB33"
                    d="M10 0L9.81 0.6 9.17 0.6 9.69 0.96 9.5 1.54 10 1.19 10.5 1.54 10.31 0.96 10.83 0.6 10.19 0.6z"
                />
                <path
                    fill="#FFEB33"
                    d="M12.59 0.68L12.39 1.27 11.76 1.27 12.28 1.64 12.09 2.22 12.59 1.86 13.08 2.22 12.9 1.64 13.41 1.27 12.78 1.27z"
                />
                <path
                    fill="#FFEB33"
                    d="M6.92 2.22L7.41 1.86 7.91 2.22 7.72 1.64 8.24 1.27 7.61 1.27 7.41 0.68 7.22 1.27 6.59 1.27 7.1 1.64z"
                />
                <path
                    fill="#FFEB33"
                    d="M13.99 4.12L14.49 3.76 14.99 4.12 14.8 3.54 15.32 3.17 14.68 3.17 14.49 2.57 14.3 3.17 13.66 3.17 14.18 3.54z"
                />
                <path
                    fill="#FFEB33"
                    d="M5.51 2.57L5.32 3.17 4.68 3.17 5.2 3.54 5.01 4.12 5.51 3.76 6.01 4.12 5.82 3.54 6.34 3.17 5.7 3.17z"
                />
                <path
                    fill="#FFEB33"
                    d="M16 5.77L15.37 5.77 15.17 5.17 14.98 5.77 14.35 5.77 14.86 6.13 14.68 6.71 15.17 6.36 15.67 6.71 15.48 6.13z"
                />
                <path
                    fill="#FFEB33"
                    d="M4.83 6.36L5.32 6.71 5.14 6.13 5.65 5.77 5.02 5.77 4.83 5.17 4.63 5.77 4 5.77 4.52 6.13 4.33 6.71z"
                />
                <path
                    fill="#FFEB33"
                    d="M14.68 8.35L14.49 7.76 14.3 8.35 13.66 8.35 14.18 8.72 13.99 9.3 14.49 8.94 14.99 9.3 14.8 8.72 15.32 8.35z"
                />
                <path
                    fill="#FFEB33"
                    d="M5.7 8.35L5.51 7.76 5.32 8.35 4.68 8.35 5.2 8.72 5.01 9.3 5.51 8.94 6.01 9.3 5.82 8.72 6.34 8.35z"
                />
                <path
                    fill="#FFEB33"
                    d="M12.78 10.25L12.59 9.65 12.39 10.25 11.76 10.25 12.28 10.62 12.09 11.19 12.59 10.84 13.08 11.19 12.9 10.62 13.41 10.25z"
                />
                <path
                    fill="#FFEB33"
                    d="M7.61 10.25L7.41 9.65 7.22 10.25 6.59 10.25 7.1 10.62 6.92 11.19 7.41 10.84 7.91 11.19 7.72 10.62 8.24 10.25z"
                />
                <path
                    fill="#FFEB33"
                    d="M10.19 10.95L10 10.35 9.81 10.95 9.17 10.95 9.69 11.32 9.5 11.9 10 11.54 10.5 11.9 10.31 11.32 10.83 10.95z"
                />
            </g>
            <g>
                <path
                    d="M4.93,20v-6.04h1.19l2.47,4.04v-4.04h1.13V20H8.5l-2.44-3.94V20H4.93z"
                />
                <path d="M11.04,20v-5.99h1.22v4.98h3.03V20H11.04z" />
            </g>
        </svg>
    `);
}

export function leads(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path d="M2 1v14h1.6V9.24h4.48l.32 1.64H14V2.65H9.52L9.2 1z" />
        </svg>
    `);
}

export function logout(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path d="M5.2 2l1.2 1.53h8.07v9.07H6.4L5.2 14H16V2z" />
            <path
                id="XMLID_152_"
                class="st0"
                d="M6.13 6.53H0v3h6.13v1.54l3.07-3-3.07-3.14z"
            />
        </svg>
    `);
}

export function loop(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M14.19,12.76l-2.67-2.65c0.6-0.88,0.96-1.95,0.96-3.1c0-3.04-2.45-5.5-5.48-5.5c-3.03,0-5.48,2.46-5.48,5.5 c0,3.04,2.45,5.5,5.48,5.5c1.16,0,2.23-0.36,3.12-0.98l2.66,2.67c0.18,0.19,0.44,0.3,0.72,0.3c0.56,0,1.01-0.45,1.01-1.01 C14.5,13.2,14.38,12.94,14.19,12.76z M6.99,10.51c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5c1.93,0,3.5,1.57,3.5,3.5 S8.93,10.51,6.99,10.51z"
            />
        </svg>
    `);
}

export function next(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M10.9,7.35l-5.8,5.8C5,13.25,4.89,13.3,4.75,13.3c-0.14,0-0.25-0.05-0.35-0.15l-1.3-1.3 c-0.1-0.1-0.15-0.22-0.15-0.35c0-0.14,0.05-0.25,0.15-0.35L7.25,7L3.1,2.85C3,2.75,2.95,2.64,2.95,2.5C2.95,2.36,3,2.25,3.1,2.15 l1.3-1.3C4.5,0.75,4.61,0.7,4.75,0.7C4.89,0.7,5,0.75,5.1,0.85l5.8,5.8C11,6.75,11.05,6.86,11.05,7C11.05,7.14,11,7.25,10.9,7.35z"
            />
        </svg>
    `);
}

export function pin(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 42">
            <path
                fill="#FFEB33"
                d="M28.84,28.67c-5.99,5.99-15.69,5.99-21.68,0c-5.99-5.99-5.99-15.69,0-21.68 C13.15,1,22.85,1,28.84,6.99C34.83,12.97,34.83,22.68,28.84,28.67z"
            />
            <path
                fill="#0028D8"
                d="M27.58,14.98H26.5c-0.24,0-0.46,0.09-0.62,0.25c-0.59-1.32-1.37-3.36-1.82-4.16 c-0.2-0.36-0.6-0.79-1.04-0.79H12.98c-0.45,0-0.85,0.43-1.04,0.79c-0.44,0.8-1.22,2.84-1.82,4.16c-0.16-0.15-0.38-0.25-0.62-0.25 H8.42c-0.51,0-0.92,0.41-0.92,0.92c0,0.51,0.41,0.92,0.92,0.92h0.96c0,0,0,0.01,0,0.01v3.4c0,0.03,0,0.05,0,0.08 c0,0.03,0,0.05,0,0.08v0.04l0,0c0.04,1.08,0.58,1.95,1.25,1.95c0,0,0.01,0,0.01,0c0,0.04-0.01,0.09-0.01,0.14v1.8 c0,0.47,0.38,0.85,0.85,0.85h0.79c0.47,0,0.85-0.38,0.85-0.85v-1.8c0-0.05-0.01-0.1-0.01-0.15l0.14,0h9.55l0.13,0 c-0.01,0.05-0.01,0.1-0.01,0.15v1.8c0,0.47,0.38,0.85,0.85,0.85h0.79c0.47,0,0.85-0.38,0.85-0.85v-1.8c0-0.05-0.01-0.09-0.01-0.14h0 c0.69,0,1.25-0.92,1.25-2.06c0-0.01,0-0.02,0-0.03l0-3.44c0,0,0-0.01,0-0.01h0.96c0.51,0,0.92-0.41,0.92-0.92 C28.5,15.39,28.09,14.98,27.58,14.98 M12.94,20.25c-0.72,0-1.31-0.59-1.31-1.31c0-0.72,0.59-1.31,1.31-1.31 c0.72,0,1.31,0.59,1.31,1.31C14.26,19.66,13.67,20.25,12.94,20.25 M22.64,20.25c-0.72,0-1.31-0.59-1.31-1.31 c0-0.72,0.59-1.31,1.31-1.31c0.72,0,1.31,0.59,1.31,1.31C23.95,19.66,23.37,20.25,22.64,20.25 M11.23,16.03 c0.57-1.22,1.08-2.96,1.75-4.16c0.05-0.08,0.19-0.28,0.29-0.32h4.69h0.1h4.69c0.1,0.04,0.24,0.24,0.29,0.32 c0.66,1.2,1.17,2.94,1.75,4.16H11.23z"
            />
            <path
                fill="#FFEB33"
                d="M30.61,5.22c-6.96-6.96-18.25-6.96-25.21,0c-6.96,6.96-6.96,18.25,0,25.21l10.84,10.84 c0.97,0.97,2.56,0.97,3.53,0l10.84-10.84C37.57,23.47,37.57,12.18,30.61,5.22z M28.84,28.67c-5.99,5.99-15.69,5.99-21.68,0 c-5.99-5.99-5.99-15.69,0-21.68C13.15,1,22.85,1,28.84,6.99C34.83,12.97,34.83,22.68,28.84,28.67z"
            />
        </svg>
    `);
}

export function highlight(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 42">
            <path
                fill="#e3f6f8"
                d="M28.84,28.67c-5.99,5.99-15.69,5.99-21.68,0c-5.99-5.99-5.99-15.69,0-21.68 C13.15,1,22.85,1,28.84,6.99C34.83,12.97,34.83,22.68,28.84,28.67z"
            />
            <path
                fill="#0028D8"
                d="M27.58,14.98H26.5c-0.24,0-0.46,0.09-0.62,0.25c-0.59-1.32-1.37-3.36-1.82-4.16 c-0.2-0.36-0.6-0.79-1.04-0.79H12.98c-0.45,0-0.85,0.43-1.04,0.79c-0.44,0.8-1.22,2.84-1.82,4.16c-0.16-0.15-0.38-0.25-0.62-0.25 H8.42c-0.51,0-0.92,0.41-0.92,0.92c0,0.51,0.41,0.92,0.92,0.92h0.96c0,0,0,0.01,0,0.01v3.4c0,0.03,0,0.05,0,0.08 c0,0.03,0,0.05,0,0.08v0.04l0,0c0.04,1.08,0.58,1.95,1.25,1.95c0,0,0.01,0,0.01,0c0,0.04-0.01,0.09-0.01,0.14v1.8 c0,0.47,0.38,0.85,0.85,0.85h0.79c0.47,0,0.85-0.38,0.85-0.85v-1.8c0-0.05-0.01-0.1-0.01-0.15l0.14,0h9.55l0.13,0 c-0.01,0.05-0.01,0.1-0.01,0.15v1.8c0,0.47,0.38,0.85,0.85,0.85h0.79c0.47,0,0.85-0.38,0.85-0.85v-1.8c0-0.05-0.01-0.09-0.01-0.14h0 c0.69,0,1.25-0.92,1.25-2.06c0-0.01,0-0.02,0-0.03l0-3.44c0,0,0-0.01,0-0.01h0.96c0.51,0,0.92-0.41,0.92-0.92 C28.5,15.39,28.09,14.98,27.58,14.98 M12.94,20.25c-0.72,0-1.31-0.59-1.31-1.31c0-0.72,0.59-1.31,1.31-1.31 c0.72,0,1.31,0.59,1.31,1.31C14.26,19.66,13.67,20.25,12.94,20.25 M22.64,20.25c-0.72,0-1.31-0.59-1.31-1.31 c0-0.72,0.59-1.31,1.31-1.31c0.72,0,1.31,0.59,1.31,1.31C23.95,19.66,23.37,20.25,22.64,20.25 M11.23,16.03 c0.57-1.22,1.08-2.96,1.75-4.16c0.05-0.08,0.19-0.28,0.29-0.32h4.69h0.1h4.69c0.1,0.04,0.24,0.24,0.29,0.32 c0.66,1.2,1.17,2.94,1.75,4.16H11.23z"
            />
            <path
                fill="#e3f6f8"
                d="M30.61,5.22c-6.96-6.96-18.25-6.96-25.21,0c-6.96,6.96-6.96,18.25,0,25.21l10.84,10.84 c0.97,0.97,2.56,0.97,3.53,0l10.84-10.84C37.57,23.47,37.57,12.18,30.61,5.22z M28.84,28.67c-5.99,5.99-15.69,5.99-21.68,0 c-5.99-5.99-5.99-15.69,0-21.68C13.15,1,22.85,1,28.84,6.99C34.83,12.97,34.83,22.68,28.84,28.67z"
            />
        </svg>
    `);
}

export function pointer(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M12.46 9.69c-.08.18-.26.31-.46.31H9.02l1.57 3.72c.11.26-.02.55-.27.66l-1.38.59c-.26.11-.55-.02-.66-.27l-1.49-3.53-2.44 2.43c-.09.09-.22.15-.35.15-.06 0-.13-.02-.19-.04-.19-.08-.31-.26-.31-.46V1.5c0-.2.12-.38.31-.46.06-.02.13-.04.19-.04.13 0 .26.05.35.15l8 8c.15.14.19.36.11.54z"
            />
        </svg>
    `);
}

export function prev(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M10.9,2.85L6.75,7l4.15,4.15c0.1,0.1,0.15,0.22,0.15,0.35c0,0.14-0.05,0.25-0.15,0.35l-1.3,1.3 c-0.1,0.1-0.22,0.15-0.35,0.15c-0.14,0-0.25-0.05-0.35-0.15l-5.8-5.8C3,7.25,2.95,7.14,2.95,7C2.95,6.86,3,6.75,3.1,6.65l5.8-5.8 C9,0.75,9.11,0.7,9.25,0.7c0.14,0,0.25,0.05,0.35,0.15l1.3,1.3c0.1,0.1,0.15,0.22,0.15,0.35C11.05,2.64,11,2.75,10.9,2.85z"
            />
        </svg>
    `);
}

export function print(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M14.5,8.5v3.25c0,0.07-0.02,0.13-0.07,0.18C14.38,11.98,14.32,12,14.25,12H12.5v1.25 c0,0.21-0.07,0.39-0.22,0.53C12.14,13.93,11.96,14,11.75,14h-7.5c-0.21,0-0.39-0.07-0.53-0.22c-0.15-0.15-0.22-0.32-0.22-0.53V12 H1.75c-0.07,0-0.13-0.02-0.18-0.07c-0.05-0.05-0.07-0.11-0.07-0.18V8.5c0-0.41,0.15-0.76,0.44-1.06C2.24,7.15,2.59,7,3,7h0.5V2.75 c0-0.21,0.07-0.39,0.22-0.53C3.86,2.07,4.04,2,4.25,2H9.5c0.21,0,0.44,0.05,0.69,0.16c0.25,0.1,0.45,0.23,0.59,0.38l1.19,1.19 c0.15,0.15,0.27,0.34,0.38,0.59C12.45,4.56,12.5,4.79,12.5,5v2H13c0.41,0,0.76,0.15,1.06,0.44C14.35,7.74,14.5,8.09,14.5,8.5z M4.5,8h7V5h-1.25c-0.21,0-0.39-0.07-0.53-0.22C9.57,4.64,9.5,4.46,9.5,4.25V3h-5V8z M4.5,13h7v-2h-7V13z M13.35,8.85 c0.1-0.1,0.15-0.22,0.15-0.35c0-0.14-0.05-0.25-0.15-0.35C13.25,8.05,13.14,8,13,8c-0.14,0-0.25,0.05-0.35,0.15 c-0.1,0.1-0.15,0.22-0.15,0.35c0,0.14,0.05,0.25,0.15,0.35C12.75,8.95,12.86,9,13,9C13.14,9,13.25,8.95,13.35,8.85z"
            />
        </svg>
    `);
}

export function prospects(): Html {
    return icon(html`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200.000000 200.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g
                transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
                stroke="none"
            >
                <path
                    d="M741 1685 c-80 -23 -129 -47 -196 -98 -137 -104 -210 -255 -208 -432
2 -207 113 -385 298 -476 158 -78 326 -79 475 -4 27 14 52 25 55 25 3 0 5 -17
5 -38 0 -35 12 -49 233 -270 l232 -232 60 60 60 60 -235 235 c-201 201 -239
235 -265 235 l-29 0 41 43 c161 166 194 417 82 628 -57 107 -175 207 -294 250
-79 28 -238 35 -314 14z m238 -80 c138 -33 246 -121 309 -252 36 -76 37 -81
37 -193 0 -109 -2 -119 -32 -182 -18 -38 -35 -68 -38 -68 -3 0 -16 10 -28 21
-30 29 -133 78 -179 85 -21 4 -38 8 -38 10 0 2 13 23 30 46 37 52 52 126 39
190 -12 64 -30 98 -78 141 -102 92 -244 63 -315 -63 -26 -47 -30 -64 -30 -125
0 -73 16 -118 57 -162 16 -18 17 -23 6 -27 -8 -2 -41 -12 -73 -22 -33 -10 -82
-33 -109 -51 -27 -18 -50 -33 -52 -33 -1 0 -15 28 -31 63 -27 57 -29 71 -29
177 0 112 1 117 36 190 64 133 163 216 298 252 82 21 138 22 220 3z m-43 -252
c34 -22 64 -84 64 -133 0 -56 -21 -101 -64 -137 -36 -29 -37 -31 -29 -79 8
-45 11 -49 38 -52 100 -11 223 -62 245 -102 8 -16 3 -24 -38 -54 -104 -76
-234 -108 -350 -87 -76 14 -170 57 -222 100 -29 25 -33 33 -24 48 17 29 117
74 196 87 l73 12 5 53 c5 48 4 54 -20 68 -43 26 -64 63 -68 125 -5 68 9 109
50 143 35 30 105 34 144 8z"
                />
            </g>
        </svg>
    `);
}

export function settings(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M14,7.15v1.73c0,0.06-0.02,0.12-0.06,0.18c-0.04,0.06-0.09,0.09-0.16,0.1l-1.45,0.22 c-0.1,0.28-0.2,0.52-0.3,0.71c0.18,0.26,0.46,0.62,0.84,1.08c0.05,0.06,0.08,0.13,0.08,0.2c0,0.07-0.02,0.13-0.07,0.18 c-0.14,0.19-0.4,0.47-0.77,0.84c-0.38,0.37-0.62,0.55-0.73,0.55c-0.06,0-0.13-0.02-0.2-0.07l-1.08-0.84 c-0.23,0.12-0.47,0.22-0.71,0.3c-0.08,0.71-0.16,1.19-0.23,1.45C9.11,13.93,9.02,14,8.87,14H7.13C7.06,14,7,13.98,6.94,13.93 c-0.05-0.04-0.08-0.1-0.09-0.17l-0.22-1.44c-0.26-0.08-0.49-0.18-0.7-0.29l-1.1,0.84c-0.05,0.05-0.12,0.07-0.2,0.07 c-0.07,0-0.14-0.03-0.2-0.09c-0.66-0.59-1.09-1.03-1.29-1.31c-0.04-0.05-0.05-0.11-0.05-0.18c0-0.06,0.02-0.12,0.06-0.18 c0.08-0.11,0.21-0.28,0.4-0.52c0.19-0.24,0.33-0.42,0.42-0.55C3.84,9.86,3.73,9.6,3.66,9.34L2.23,9.13C2.16,9.12,2.1,9.09,2.06,9.04 C2.02,8.98,2,8.92,2,8.85V7.12C2,7.05,2.02,7,2.06,6.94c0.04-0.06,0.09-0.09,0.15-0.1l1.45-0.22c0.07-0.24,0.17-0.48,0.3-0.72 C3.76,5.6,3.48,5.24,3.13,4.82C3.08,4.76,3.05,4.7,3.05,4.63c0-0.05,0.02-0.11,0.07-0.18c0.14-0.19,0.39-0.47,0.77-0.84 c0.38-0.37,0.62-0.56,0.74-0.56c0.07,0,0.14,0.03,0.2,0.08l1.08,0.84c0.23-0.12,0.47-0.22,0.71-0.3c0.08-0.71,0.16-1.19,0.23-1.45 C6.89,2.07,6.98,2,7.13,2h1.73C8.94,2,9,2.02,9.06,2.07c0.05,0.04,0.08,0.1,0.09,0.17l0.22,1.44c0.25,0.08,0.49,0.18,0.7,0.29 l1.11-0.84c0.05-0.05,0.11-0.07,0.19-0.07c0.07,0,0.13,0.03,0.2,0.08c0.67,0.62,1.1,1.06,1.29,1.33c0.04,0.04,0.05,0.1,0.05,0.17 c0,0.06-0.02,0.12-0.06,0.18c-0.08,0.11-0.21,0.28-0.4,0.52c-0.19,0.24-0.33,0.42-0.42,0.55c0.14,0.26,0.24,0.52,0.32,0.77 l1.43,0.22c0.07,0.01,0.12,0.04,0.16,0.1C13.98,7.02,14,7.08,14,7.15z M9.41,9.41C9.8,9.02,10,8.55,10,8c0-0.55-0.2-1.02-0.59-1.41 S8.55,6,8,6C7.45,6,6.98,6.2,6.59,6.59S6,7.45,6,8c0,0.55,0.2,1.02,0.59,1.41S7.45,10,8,10C8.55,10,9.02,9.8,9.41,9.41z"
            />
        </svg>
    `);
}

export function trash(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M12.43,3.07C12.38,3.02,12.32,3,12.25,3H9.84L9.29,1.7C9.21,1.5,9.07,1.34,8.87,1.2C8.66,1.07,8.46,1,8.25,1 h-2.5C5.54,1,5.34,1.07,5.13,1.2C4.93,1.34,4.79,1.5,4.71,1.7L4.16,3H1.75C1.68,3,1.62,3.02,1.57,3.07S1.5,3.18,1.5,3.25v0.5 c0,0.07,0.02,0.13,0.07,0.18S1.68,4,1.75,4H2.5v7.6c0,0.77,0.63,1.4,1.4,1.4h6.2c0.77,0,1.4-0.63,1.4-1.4V4h0.75 c0.07,0,0.13-0.02,0.18-0.07s0.07-0.11,0.07-0.18v-0.5C12.5,3.18,12.48,3.12,12.43,3.07z M5.63,2.09C5.67,2.04,5.71,2.01,5.77,2 h2.48c0.05,0.01,0.1,0.04,0.13,0.09L8.75,3h-3.5L5.63,2.09z M5.5,10.75C5.5,10.89,5.39,11,5.25,11H4.75c-0.14,0-0.25-0.11-0.25-0.25 V5.25C4.5,5.11,4.61,5,4.75,5h0.49C5.39,5,5.5,5.11,5.5,5.25V10.75z M7.5,10.75C7.5,10.89,7.39,11,7.25,11H6.75 c-0.14,0-0.25-0.11-0.25-0.25V5.25C6.5,5.11,6.61,5,6.75,5h0.49C7.39,5,7.5,5.11,7.5,5.25V10.75z M9.5,10.75 C9.5,10.89,9.39,11,9.25,11H8.75c-0.14,0-0.25-0.11-0.25-0.25V5.25C8.5,5.11,8.61,5,8.75,5h0.49C9.39,5,9.5,5.11,9.5,5.25V10.75z"
            />
        </svg>
    `);
}

export function vergelijken(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M14.25,11.92c0,0.14-0.11,0.25-0.25,0.25H4.25v1.75c0,0.1-0.05,0.19-0.15,0.23s-0.2,0.02-0.27-0.04l-3-2.73
	c-0.05-0.05-0.08-0.11-0.08-0.18s0.03-0.14,0.08-0.19l3-2.77C3.91,8.17,4.01,8.16,4.1,8.2c0.09,0.04,0.15,0.12,0.15,0.23v1.75H14
	c0.14,0,0.25,0.11,0.25,0.25V11.92z"
            />
            <path
                d="M15.17,4.99l-3,2.77c-0.08,0.07-0.18,0.09-0.27,0.05c-0.09-0.04-0.15-0.12-0.15-0.23V5.83H2
	c-0.14,0-0.25-0.11-0.25-0.25v-1.5c0-0.14,0.11-0.25,0.25-0.25h9.75V2.08c0-0.1,0.05-0.19,0.15-0.23s0.2-0.02,0.27,0.04l3,2.73
	c0.05,0.05,0.08,0.11,0.08,0.18S15.22,4.95,15.17,4.99z"
            />
        </svg>
    `);
}

export function video(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M13,10.64c0,0.17-0.11,0.33-0.26,0.4c-0.05,0.02-0.11,0.03-0.17,0.03c-0.11,0-0.22-0.04-0.3-0.13l-2.7-2.7 v1.11c0,1.06-0.86,1.93-1.93,1.93H2.93C1.86,11.29,1,10.42,1,9.36V4.64c0-1.06,0.86-1.93,1.93-1.93h4.72 c1.06,0,1.93,0.86,1.93,1.93v1.11l2.7-2.69c0.08-0.09,0.19-0.13,0.3-0.13c0.05,0,0.11,0.01,0.17,0.03C12.9,3.03,13,3.18,13,3.36 V10.64z"
            />
        </svg>
    `);
}

export function voorraad(): Html {
    return icon(html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
            <path
                d="M20.77,7.7h-0.85c-0.19,0-0.36,0.07-0.49,0.19c-0.47-1.04-1.16-2.83-1.51-3.47 c-0.16-0.28-0.47-0.62-0.82-0.62H9.31c-0.35,0-0.67,0.34-0.82,0.62c-0.14,0.26-0.34,0.7-0.55,1.21h1.1c0.09-0.2,0.18-0.4,0.28-0.57 C9.35,5,9.46,4.85,9.54,4.81h7.33c0.08,0.03,0.19,0.19,0.23,0.25c0.52,0.95,1.01,2.5,1.46,3.46h-3.42c0.02,0.04,0.04,0.09,0.05,0.13 c0.1,0.23,0.19,0.47,0.29,0.69c0.01,0,0.03,0,0.04,0h0.85c0.85,0,1.54,0.69,1.54,1.54c0,0.83-0.66,1.51-1.49,1.54l0,0.82h0.55 l0.11,0c-0.01,0.04-0.01,0.07-0.01,0.11v1.42c0,0.37,0.3,0.67,0.67,0.67h0.62c0.37,0,0.67-0.3,0.67-0.67v-1.42 c0-0.04,0-0.07-0.01-0.11h0c0.55,0,0.99-0.73,0.99-1.63c0-0.01,0-0.02,0-0.02l0-2.45c0,0,0-0.01,0-0.01h0.76 c0.4,0,0.73-0.32,0.73-0.73C21.5,8.02,21.17,7.7,20.77,7.7z"
            />
            <g>
                <path
                    d="M16.37,10.17h-0.85c-0.19,0-0.36,0.07-0.49,0.19c-0.47-1.04-1.09-2.66-1.44-3.29 c-0.16-0.28-0.47-0.62-0.82-0.62H4.83c-0.35,0-0.67,0.34-0.82,0.62c-0.35,0.63-0.97,2.25-1.44,3.29c-0.13-0.12-0.3-0.19-0.49-0.19 H1.23c-0.4,0-0.73,0.32-0.73,0.73c0,0.4,0.33,0.73,0.73,0.73h0.76c0,0,0,0,0,0.01v2.68c0,0.02,0,0.04,0,0.06c0,0.02,0,0.04,0,0.06 v0.03l0,0C2.01,15.32,2.44,16,2.97,16c0,0,0.01,0,0.01,0c0,0.04-0.01,0.07-0.01,0.11v1.42c0,0.37,0.3,0.67,0.67,0.67h0.62 c0.37,0,0.67-0.3,0.67-0.67v-1.42c0-0.04,0-0.08-0.01-0.11l0.11,0h7.55l0.11,0c-0.01,0.04-0.01,0.07-0.01,0.11v1.42 c0,0.37,0.3,0.67,0.67,0.67h0.62c0.37,0,0.67-0.3,0.67-0.67v-1.42c0-0.04,0-0.07-0.01-0.11h0c0.55,0,0.99-0.73,0.99-1.63 c0-0.01,0-0.02,0-0.02l0-2.72c0,0,0-0.01,0-0.01h0.76c0.4,0,0.73-0.32,0.73-0.73C17.1,10.49,16.77,10.17,16.37,10.17 M4.8,14.33 c-0.57,0-1.04-0.46-1.04-1.04c0-0.57,0.46-1.04,1.04-1.04c0.57,0,1.04,0.46,1.04,1.04C5.84,13.87,5.37,14.33,4.8,14.33z M12.47,14.33c-0.57,0-1.04-0.46-1.04-1.04c0-0.57,0.46-1.04,1.04-1.04c0.57,0,1.04,0.46,1.04,1.04 C13.5,13.87,13.04,14.33,12.47,14.33z M3.45,11c0.45-0.96,0.86-2.34,1.38-3.28c0.04-0.07,0.15-0.22,0.23-0.25h7.49 c0.08,0.03,0.19,0.19,0.23,0.25c0.52,0.95,0.93,2.32,1.38,3.28H3.45z"
                />
            </g>
        </svg>
    `);
}

//---- Internals ----//

export function icon(content: Html): Html {
    return html`<ata-icon>${content}</ata-icon>`;
}

@customElement('ata-icon')
export class AtaIcon extends LitElement {
    static styles = css`
        :host {
            display: flex;
            place-items: center;
            aspect-ratio: 1;
            height: 100%;
        }
    `;

    protected render(): Html {
        return html`<slot></slot>`;
    }
}
